import Cookies from 'js-cookie';

const NS = 'ProgramNewVisitorModal';
const CLS = 'programNewVisitorModal';

export class ProgramNewVisitorModal {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		// Get Cookie
		const popupSeenCookieName = 'woolmarkProgramNewVisitorModalSeen';
		const popupSeenCookieValue = Cookies.get(popupSeenCookieName);

		if(typeof popupSeenCookieValue !== 'undefined') {
			// Popup already seen, do nothing			
			// console.log('removing cookie', popupSeenCookieValue);
		}
		else {
			// Popup not seen, 1st time visitor. Set cookie and show popup
			Cookies.set(popupSeenCookieName, 'true', { expires: 7 });
			if(this.$element.data('show') && this.$element.hasClass('modal')) {
				setTimeout(function() {
					$(element).modal('show');
				}, 2000);
			}
			// console.log('setting cookie', popupSeenCookieValue);
		}
	}
}
